import "./Home.css";
import newsPaper from "../images/newsp.jpg";
import newsPaper2 from "../images/newsp1.jpg"

import familyImage from "../images/family.jpg";

import familyImage2 from "../images/family2.jpg";

import selfVideo from "../images/vid.mp4";


import { useState } from "react";
import ImageSlider from "./ImageSlider";
import ScrollGallery from "./ScrollGallary";

const Home = () => {
  

  const [showVideo, setShowVideo] = useState(false);
  const [changePic, setChangePic] = useState(false);

  return (
    <main className="main-container">
      <section className="container-one">
        <div className="container-one-part1">
          <h1>
            Married Public Figure
            <span className="danger-word"> Leaked Intimate</span> Content
          </h1>
         
          <p>
           In a shocking turn of events <strong>Doug Butler</strong> working at Oakland Hot Springs Married and a father has come under intense scrutiny allegedly leaking his private intimate videos and photos on various social media platforms.The content, which appears to depict Doug Butler in compromising situations, was shared without apparent consent from involved parties and has sparked widespread outrage across the internet.
Sources are unknown and the leaks began late last week when various pieces of information leaked by unknown individuals shared that Doug has the habit of sharing he’s private content with women across the internet and it’s been believed he shares he’s content with minors. 
Doug Butler’s wife Tammy Hartline Butler has not issued any public statement, but insider report believes that’s she has no knowledge of her husband’s doing online . 
Doug Butler has been sharing filthy stuff with women and children he met online for a very long period of time, this act has drawn condemnation from family advocacy groups, online safety experts, and netizens alike, who argue it sets a dangerous precedent in an era where digital privacy is increasingly fragile.
Authorities should investigating whether the leaks violate local laws. 
He should be fine or imprisoned ,action needs to be taken. 
<em style={{color:"tomato",display:"block"}}>Caution: </em> <i>Children learn from adult examples seeing someone get away with leaking content (even if facing backlash) might encourage them to share personal info recklessly, heightening risks of exploitation by predators or identity theft.<strong style={{color:"tomato"}}>Arkansas, USA- March 7,2026</strong> </i>

          </p>
         
        </div>
        <div className="job-image-container">
          <ImageSlider />
          <p>
            <i> Doug Butler</i>
          </p>
        </div>

        <div className="news-paper-container">
          <img
            className="new-paper-image"
            src={changePic ? newsPaper2 : newsPaper}
            alt=" news paper"
          />
          <div>
            
            <>
              
             <p>
            “Think carefully before sharing such pictures. Once they’re out
            there, you can’t take them back. It’s not just about you your
            family, especially the younger ones who look up to you, will see and
            remember. Protect your dignity and theirs. You may think it’s just a
            moment, but once those images spread, your family carries the shame
            too. Don’t trade dignity for a few clicks.
          </p>
              <span
                style={{ color: "red", cursor: "pointer" }}
                role="button"
                onClick={() => setChangePic(!changePic)}
              >
                <i>Tap see photo</i>
              </span>
            </>
          </div>
        </div>
      </section>

      
      <h3  style={{textAlign:"center"}}>Family</h3>
      <section className="container-two">
        <div className="container-two-part1">
          <img className="family-image1" src={familyImage} alt="" />
          <p>
           Doug Butler’s wife Tammy Hartline Butler has not issued any public statement, but insider report believes that’s she has no knowledge of her husband’s doing online 
          </p>
        </div>
        <div className="container-two-part2">
          <img className="family-image" src={familyImage2} alt="" />
          <p>
             Children learn from adult examples seeing someone get away with leaking content (even if facing backlash) might encourage them to share personal info recklessly, heightening risks of exploitation by predators or identity theft.
          </p>
        </div>
      </section>
    <section>
      <h4 style={{textAlign:"center",margin:"1rem 0"}}>Family gallary</h4>
      <ScrollGallery/>
    </section>
      <section>
        <div className="stage1">
          {/* clickable text */}
          <p className="click-text" onClick={() => setShowVideo(!showVideo)}>
            ▶ Click here to watch the video
          </p>

          {/* show video only if clicked */}
          {showVideo && (
            <div className="video-container">
              <video controls autoPlay>
                <source src={selfVideo} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          )}
        </div>
      </section>
    </main>
  );
};

export default Home;
